const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

const SHORT_MONTHS = MONTHS.map((m) => m.slice(0, 3));

function pad(n) {
  return n < 10 ? '0' + n : '' + n;
}

export function key(d) {
  return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
}

export function parse(s) {
  const p = s.split('-');
  return new Date(+p[0], +p[1] - 1, +p[2]);
}

export function addDays(s, n) {
  const d = parse(s);
  d.setDate(d.getDate() + n);
  return key(d);
}

export function diff(a, b) {
  return Math.round((parse(b) - parse(a)) / 86400000);
}

export function todayKey() {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return key(d);
}

export function expand(ranges) {
  const out = [];
  ranges.forEach((r) => {
    let c = r[0];
    while (c <= r[1]) {
      out.push(c);
      c = addDays(c, 1);
    }
  });
  return out;
}

export function fmtShort(s) {
  const d = parse(s);
  return d.getDate() + ' ' + SHORT_MONTHS[d.getMonth()];
}

export function fmtLong(s) {
  const d = parse(s);
  return d.getDate() + ' ' + SHORT_MONTHS[d.getMonth()] + ' ' + d.getFullYear();
}

export function monthLabel(year, month) {
  return MONTHS[month] + ' ' + year;
}

export function freeRun(start, blockedSet, maxDays = 365) {
  let n = 0;
  let c = start;
  while (!blockedSet.has(c) && n < maxDays) {
    n++;
    c = addDays(c, 1);
  }
  return n;
}

export function spanFree(a, b, blockedSet) {
  let c = a;
  while (c < b) {
    if (blockedSet.has(c)) return false;
    c = addDays(c, 1);
  }
  return true;
}
